import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const GuidedTrainingHome = ({ setView }) => {
	  const buttons = [
		      { label: "Internal Goldbook", view: "guidedtraining" },
		      { label: "Internal LMS", view: "guidedtraining" },
		      { label: "Guided Training", view: "guidedtraining" },
		      { label: "Guided Training (Spanish)", view: "guidedtrainingesp" },
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Guided Training Home
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default GuidedTrainingHome;

